// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","tooltip":"_13Tg-","tooltipContentContainer":"_2GdpA","tooltipContent":"_2TK82","tooltipTitle":"_1Ymh9","arrow":"_11tUw"};